import * as PropTypes from 'prop-types';
import React from 'react';
import { allow } from '../../classes/allow';
import translate from '../../functions/translate';
import useViewport from '../../hooks/use.viewport';
import is from '../../objects/is';
import the from '../../objects/the';
import Div from '../div';
import InputField from '../input.field';
import SuffixDropdown from '../suffix.dropdown';

const LastNameSection = props => {
   const {width} = useViewport();
   
   const updateSuffix = (event = {}) => {
      allow.anObject(event, is.not.empty);
      const suffix = event.target.value;
      props.onSuffixChange(suffix);
   };
   
   const onLastNameChange = (event) => {
      props.onLastNameChange(event.target.value);
   };

   return <>
      {width < the.minimumMediumViewportWidth &&
      <Div isRow={true}>
         <Div cols={12}>
            <InputField
               aria-invalid={(!!props.errorMessage).toString()}
               errorMessage={props.errorMessage}
               inputRef={props.inputRef}
               label={translate('Last name')}
               name={translate('Last name')}
               onBlur={props.onLastNameBlur}
               onChange={onLastNameChange}
               value={props.lastNameVal}
            />
         </Div>
         <Div cols={12}>
            <SuffixDropdown
               onChange={updateSuffix}
               value={props.suffixVal}
            />
         </Div>
      </Div>}
   
      {width > the.minimumMediumViewportWidth &&
      <Div isRow={true}>
         <Div cols={4}>
            <InputField
               aria-invalid={(!!props.errorMessage).toString()}
               errorMessage={props.errorMessage}
               inputRef={props.inputRef}
               label={translate('Last name')}
               name={translate('Last name')}
               onBlur={props.onLastNameBlur}
               onChange={onLastNameChange}
               value={props.lastNameVal}
            />
         </Div>
         <Div cols={2} paddingLeft={0}>
            <SuffixDropdown
               onChange={updateSuffix}
               value={props.suffixVal}
            />
         </Div>
      </Div>}
   </>
}

LastNameSection.propTypes = {
   onLastNameChange: PropTypes.func,
   onLastNameBlur: PropTypes.func,
   onSuffixChange: PropTypes.func,
   errorMessage: PropTypes.string,
   forceError: PropTypes.bool,
   inputRef: PropTypes.func,
   lastNameVal: PropTypes.string,
   suffixVal: PropTypes.string
};

export default LastNameSection;